import { Field } from 'formik';
import React from 'react';
import { InputTextWithValidationMessageAndToolip } from '../../../components/prime-formik';

const OrganisationSizeInput = () => {
  return (
    <div className="p-col-12">
      <Field
        name="organisationSize"
        type="number"
        labelText="Size of your organisation"
        component={InputTextWithValidationMessageAndToolip}
        tooltipText={`The total number of long-term relations in your organisation e.g., total number of employees in your company, total number of employees and enrolled students in your university, etc.
                    \nWe use the number you enter to help your organisation in being GDPR compliant. For example, if the number of Internal Respondents on file exceeds the number you enter, we will notify you so you can take appropriate action, if required.
                    \nIf the number changes, you can always adjust it.`}
      />
    </div>
  );
};

export default OrganisationSizeInput;
